import { render, staticRenderFns } from "./orderQuery.vue?vue&type=template&id=16c44eff&"
import script from "./orderQuery.vue?vue&type=script&lang=js&"
export * from "./orderQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports